import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { pluck, map } from 'rxjs/operators';
import { ImagilityBaseResponse } from 'src/app/data/models/response.model';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FreeTrialService {
companyData;
userInfo;
beneficiaryInfo;
companyInfo;
firmInfoData;
linkRequestCode;
beneficiaryInfoArray: any = [];
  companyClientFirmInfo: any;
  firmUserInfoAttorney: any;
  beneCount: any;
  userInfoArray: any;
  countUsers: any;
  attorneyuserInfoArray: any;
  nameCompany: any;
  getFreeTrailplan: any;
  attorneyuserInfoArrayEdit: any;
  attorneyfirstLastName: any;
constructor(private httpClient: HttpClient, private route: ActivatedRoute) {
 }


 setPlanFlow(plan) {
  this.getFreeTrailplan = plan;
 }
 getFreeTrailPlan() {
  return this.getFreeTrailplan;
 }

 setbeneficiaryCount(countBene) {
  this.beneCount = countBene;
 }

 getbeneficiaryCount()
 {
    return this.beneCount;
 }

 setuserCount(countuser) {
  this.countUsers = countuser;
 }

 getuserCount() {
  return this.countUsers;
 }

 setcompanyInfo(companyInfo)
 {
   this.companyInfo = companyInfo;
 }

 getcompanyInfo()
 {
    return this.companyInfo;
 }

 setFirmInfo(firmInfo) {
  this.firmInfoData = firmInfo;
 }
 getFirmInfo()
 {
    return this.firmInfoData;
 }

 getuserInfo()
 {
    return this.userInfo;
 }

 setuserInfo(userInfo)
 {
   this.userInfo = userInfo;
 }

 setFirmUserInfo(firmUserInfo) {
  this.firmUserInfoAttorney = firmUserInfo;
 }

 getFirmUserInfoAttorney()
 {
    return this.firmUserInfoAttorney;
 }

 getBeneficiaryInfo()
 {
    return this.beneficiaryInfo;
 }

 setbeneficiaryInfo(beneficiaryInfo)
 {
   this.beneficiaryInfo = beneficiaryInfo;
 }

 setbeneficiaryInforray(beneficiaryInfoArray)
 {
   this.beneficiaryInfoArray = beneficiaryInfoArray;
 }

 getBeneficiaryInfoArray()
 {
    return this.beneficiaryInfoArray;
 }

 setuserInfoarray(userArray) {
  this.userInfoArray = userArray;
 }

 getUserInfoArray()
 {
    return this.userInfoArray;
 }

 setattorneyuserInfoarray(attorneyuserArray) {
  this.attorneyuserInfoArray = attorneyuserArray;
 }

 getattorneyUserInfoArray()
 {
  if (this.attorneyuserInfoArray === undefined) {
    return this.attorneyuserInfoArray = [];
  } else {
    return this.attorneyuserInfoArray;
  }
 }

 setattorneyuserInfoarrayEdit(attorneyuserArrayEdit) {
  this.attorneyuserInfoArrayEdit = attorneyuserArrayEdit;
 }

 getattorneyUserInfoArrayEdit() {
    return this.attorneyuserInfoArrayEdit;
 }

 setCompanyClientFirstLastName(firstName, lastname) {
  this.attorneyfirstLastName = firstName + lastname;
 }

 getCompanyClientFirstLastName() {
  return this.attorneyfirstLastName;
 }



setLinkRequestCode(linkCode) {
  this.linkRequestCode = linkCode;
}

 getLinkRequestCode() {
   return this.linkRequestCode;
 }

 setCompanyClientFirmInfo(payload) {
    this.companyClientFirmInfo = payload;
 }

 getCompanyClientFirmInfo() {
  return this.companyClientFirmInfo;
 }

getFreeTrialList(payload){
  return this.httpClient.post(`/admin/getListOfFreeTrialPlan`, payload).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

postSendInvite(freeTrialPlanId, payload){
  return this.httpClient.post(`/admin/linkRequest/${freeTrialPlanId}`, payload).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

getDetailsBasedLinkcode(linkRequestCodecompanyId){
  return this.httpClient.get(`/admin/getLinkRequest/${linkRequestCodecompanyId}`).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

getReviewSummary(companyId){
  return this.httpClient.get(`/attorney/company/${companyId}/reviewSummary`).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

postReviewSummary(companyId,payload){
  return this.httpClient.post(`/attorney/company/${companyId}/reviewSummary`,payload).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

postReviewSummaryPetitionerFlow(link, payload){
  const reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('tokenFetch')
 });
  return this.httpClient.post(`/freeTrial/company/createThroughLinkRequest/${link}`, payload, { headers: reqHeader }).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

postReviewSummaryAttorneyFlow(){
  // tslint:disable-next-line:max-line-length
  return this.httpClient.post(`/freeTrial/company/createThroughLinkRequest/${this.linkRequestCode}`, this.companyData).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

getUserRoles(){
  return this.httpClient.get(`/default/user/roles`).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

getUserRolesByCompany(companyId){
  return this.httpClient.get(`/company/${companyId}/role`).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

getUserDetails(companyId, payload){
  return this.httpClient.post(`/company/${companyId}/user/roles/list`, payload).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

getBeneficiaryDetails(companyId){
  return this.httpClient.get(`/beneficiaries/company/${companyId}`).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

getSendInviteList(companyId){
  return this.httpClient.get(`/getSendInviteListFromLinkRequestByCompany/${companyId}`).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

createSendInviteBeneficiary(payload){
  return this.httpClient.post(`/petitioner/dashboard/beneficiaries/create`, payload).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

assignRoles(companyId,payload){
  return this.httpClient.post(`/company/${companyId}/assignRoles`, payload).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

deleteUser(companyId,employeeId){
  return this.httpClient.delete(`/company/${companyId}/createUser/${employeeId}`).pipe(
    map((response: ImagilityBaseResponse) => {
        return response; // send  full data
    })
  );
 }

//  deleteBeneficiary(companyId,beneficiary_id){
//   return this.httpClient.delete(`/beneficiary/${beneficiary_id}/profile/deleteByAttorney/${companyId}`).pipe(
//     map((response: ImagilityBaseResponse) => {
//         return response; // send  full data
//     })
//   );
//  }

 deleteSendInviteBeneficiary(linkRequestId){
  return this.httpClient.delete(`/attorney/deleteLinkRequest/${linkRequestId}`).pipe(
    map((response: ImagilityBaseResponse) => {
        return response; // send  full data
    })
  );
 }

 deleteDraftClient(companyId,employeeId){
  return this.httpClient.delete(`/company/${companyId}/createUser/${employeeId}`).pipe(
    map((response: ImagilityBaseResponse) => {
        return response; // send  full data
    })
);
 } 

 delinkConnection(petitionerId,attorneyCompanyId){
  return this.httpClient.post(`/petitioner/${petitionerId}/deLinkWithAttorney/${attorneyCompanyId}`, []).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
 }

 setCompanyNmaePopulated(companyName) {
  this.nameCompany = companyName;
 }

 getCompanyNmaePopulated() {
   return this.nameCompany;
}
}
